module.exports = __webpack_public_path__ + "public/img/arrow-r.318d489e.svg";